import serializeQueryParams from './serializeQueryParams';

export default ($axios) => ({
    async find(queryParams = null) {
        let params = queryParams ? '?' + serializeQueryParams(queryParams) : '';

        return await $axios.get(`/${URI_LANGUAGE}/frontend/category${params}`);
    },
    async findOne($categoryId, queryParams = null) {
        let params = queryParams ? '?' + serializeQueryParams(queryParams) : '';

        return await $axios.get(`/${URI_LANGUAGE}/frontend/category/${$categoryId}${params}`);
    }
})